// @ts-nocheck

import { createFileRoute, useNavigate } from '@tanstack/react-router'
import '../App.css'
import '@fontsource/montserrat';
import MyProfile from '../components/Profile/MyProfile';

export const Route = createFileRoute('/me')({
  component: RouteComponent,
})

function RouteComponent() {
  
  return <MyProfile/>
}

